var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTvIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M673.73,318.42h-180.75c-3.23,0-5.86-2.63-5.86-5.86V49.28c0-3.23,2.63-5.86,5.86-5.86h180.75c3.23,0,5.86,2.63,5.86,5.86V312.55c0,3.23-2.63,5.86-5.86,5.86ZM492.99,43.67c-3.09,0-5.61,2.52-5.61,5.61V312.55c0,3.09,2.52,5.61,5.61,5.61h180.75c3.09,0,5.61-2.52,5.61-5.61V49.28c0-3.09-2.52-5.61-5.61-5.61h-180.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.31,318.42h-180.75c-3.23,0-5.86-2.63-5.86-5.86V49.28c0-3.23,2.63-5.86,5.86-5.86h180.75c3.23,0,5.86,2.63,5.86,5.86V312.55c0,3.23-2.63,5.86-5.86,5.86ZM284.56,43.67c-3.09,0-5.61,2.52-5.61,5.61V312.55c0,3.09,2.52,5.61,5.61,5.61h180.75c3.09,0,5.61-2.52,5.61-5.61V49.28c0-3.09-2.52-5.61-5.61-5.61h-180.75Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M257.01,318.42H76.27c-3.23,0-5.86-2.63-5.86-5.86V49.28c0-3.23,2.63-5.86,5.86-5.86h180.75c3.23,0,5.86,2.63,5.86,5.86V312.55c0,3.23-2.63,5.86-5.86,5.86ZM76.27,43.67c-3.09,0-5.61,2.52-5.61,5.61V312.55c0,3.09,2.52,5.61,5.61,5.61h180.75c3.09,0,5.61-2.52,5.61-5.61V49.28c0-3.09-2.52-5.61-5.61-5.61H76.27Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    y: 379.49,
    width: 750,
    height: 0.12,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 653.63,
    y: 408.86,
    width: 55.73,
    height: 0.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 495.04,
    y: 413.43,
    width: 14.63,
    height: 0.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.64,
    y: 396.06,
    width: 72.67,
    height: 0.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.3,
    y: 396.06,
    width: 10.66,
    height: 0.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.59,
    y: 403.17,
    width: 157.61,
    height: 0.42,
    style: {
      fill: "#ebebeb"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 595.33,
    y: 71.67,
    width: 64.78,
    height: 122.12,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 580.84,
    y: 71.67,
    width: 76.09,
    height: 122.12,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 592.41,
    y: 82.51,
    width: 52.92,
    height: 100.42,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M616.46,105.77c-2.66,3.39-4.76,7.14-6.16,11.22-1.41,4.11-2.32,8.72-1.63,13.05,.59,3.69,2.78,7.27,6.33,8.75,3.81,1.59,7.81,.07,10.87-2.36,2.84-2.26,6.5-6.21,5.55-10.17s-5.92-4.95-9.33-3.56c-7.81,3.18-11.52,12.16-12.12,20.02-.63,8.31,.72,22.01,10.99,23.85,1.89,.34,2.7-2.55,.8-2.89-7.32-1.32-8.59-10.26-8.85-16.34-.29-6.77,1.1-14.02,6.09-18.95,1.95-1.92,5.45-4.56,8.27-2.92,3.26,1.9-.47,6-2.16,7.63-2.15,2.08-5.22,4.02-8.33,3.16-2.93-.81-4.64-3.76-5.15-6.58-.7-3.85,.26-8.05,1.49-11.7,1.23-3.64,3.09-7.08,5.46-10.1,1.18-1.5-.93-3.64-2.12-2.12h0Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 99.19,
    y: 65.77,
    width: 62.51,
    height: 117.84,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.2,
    y: 65.77,
    width: 73.42,
    height: 117.84,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.36,
    y: 76.23,
    width: 51.07,
    height: 96.9,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M119.53,98.63c-2.55,3.25-4.55,6.82-5.91,10.72s-2.28,8.44-1.64,12.64c.55,3.6,2.64,7.11,6.09,8.57,3.77,1.61,7.71,.08,10.73-2.35,2.79-2.25,6.55-6.39,5.1-10.29s-6.01-4.23-9.26-2.8c-7.48,3.3-10.92,12.01-11.4,19.65s.87,20.87,10.67,22.64c1.89,.34,2.7-2.55,.8-2.89-6.92-1.25-8.19-9.59-8.48-15.37-.33-6.46,.87-13.42,5.52-18.26,1.8-1.87,4.99-4.47,7.79-3.37,3.74,1.47,.22,5.68-1.45,7.33-2.08,2.07-5.09,4.06-8.16,3.21-2.85-.79-4.47-3.67-4.95-6.41-.66-3.71,.3-7.79,1.5-11.3s2.96-6.72,5.21-9.59c1.18-1.5-.93-3.64-2.12-2.12h0Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 212.97,
    y: 65.77,
    width: 321.08,
    height: 182.29,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 218.57,
    y: 71.58,
    width: 309.87,
    height: 170.16,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "526.5 213.4 525.8 213.4 525.8 194.28 521.85 194.28 521.85 189.29 512.7 189.29 512.7 172.25 507.69 172.25 507.69 160.2 501.54 160.2 501.54 142.64 499.34 142.64 499.34 160.2 493.18 160.2 493.18 172.25 488.18 172.25 488.18 189.29 479.03 189.29 479.03 194.28 475.08 194.28 475.08 213.82 473.75 213.82 473.75 186.59 471.54 186.59 471.54 204.05 469.09 204.05 469.09 162.48 466.88 162.48 466.88 179.94 460.73 179.94 460.73 173.5 457.82 173.5 457.82 149.81 456.07 149.81 456.07 149.39 453.16 149.39 453.16 125.69 451.09 125.69 451.09 129.18 416.97 129.18 416.97 118.59 411.15 118.59 411.15 80.97 408.86 80.97 408.86 118.59 400.76 118.59 400.76 129.18 397.02 129.18 397.02 179.07 379.56 179.07 379.56 164.1 385.79 164.1 385.79 161.19 379.56 161.19 379.56 157.45 362.93 157.45 362.93 119.21 358.77 119.21 358.77 113.39 339.24 113.39 339.24 119.21 336.33 119.21 336.33 172 327.18 172 327.18 196.53 322.5 196.53 322.5 176.99 318.55 176.99 318.55 172 309.41 172 309.41 154.96 304.4 154.96 304.4 142.9 298.24 142.9 298.24 125.34 296.05 125.34 296.05 142.9 289.89 142.9 289.89 154.96 284.88 154.96 284.88 172 275.74 172 275.74 176.99 271.79 176.99 271.79 196.53 265.79 196.53 265.79 145.19 263.58 145.19 263.58 162.65 255.69 162.65 255.69 196.53 252.78 196.53 252.78 132.09 249.87 132.09 249.87 108.4 247.79 108.4 247.79 116.79 232.79 123.78 232.79 132.09 225.76 132.09 225.76 196.53 220.9 196.53 220.9 215.05 218.59 215.05 218.59 241.83 528.46 241.83 528.46 213.82 526.5 213.82 526.5 213.4",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "271.9 241.74 271.9 231.08 267.95 231.08 267.95 226.08 258.81 226.08 258.81 209.04 253.8 209.04 253.8 196.99 247.64 196.99 245.45 196.99 239.29 196.99 239.29 209.04 234.28 209.04 234.28 226.08 225.14 226.08 225.14 231.08 221.18 231.08 221.18 241.74 271.9 241.74",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.82 162.49 293.82 186.19 290.91 186.19 290.91 186.6 289.16 186.6 289.16 210.29 286.25 210.29 286.25 216.73 277.89 216.73 277.89 240.85 273.24 240.85 273.24 241.74 526.08 241.74 526.08 233.32 521.22 233.32 521.22 168.89 514.19 168.89 514.19 160.58 497.11 152.61 497.11 168.89 494.2 168.89 494.2 233.32 491.29 233.32 491.29 199.44 481.19 199.44 481.19 233.32 475.2 233.32 475.2 213.78 471.24 213.78 471.24 208.79 462.1 208.79 462.1 191.75 457.09 191.75 457.09 179.69 450.93 179.69 448.74 179.69 442.58 179.69 442.58 191.75 437.58 191.75 437.58 208.79 428.43 208.79 428.43 213.78 424.48 213.78 424.48 233.32 419.8 233.32 419.8 208.79 410.65 208.79 410.65 156 407.74 156 407.74 150.18 388.21 150.18 388.21 156 384.05 156 384.05 194.24 367.42 194.24 367.42 197.98 367.42 200.89 367.42 215.86 349.97 215.86 349.97 165.98 346.22 165.98 346.22 155.38 338.12 155.38 335.83 155.38 330.02 155.38 330.02 165.98 295.89 165.98 295.89 162.49 293.82 162.49",
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 368.58,
    y: 71.58,
    width: 9.86,
    height: 170.05,
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M406.93,444.53c.63,0,1.18-.47,1.27-1.1l11.58-87.5h19.29l11.59,87.5c.09,.69,.72,1.19,1.44,1.09,.7-.09,1.2-.73,1.1-1.42l-11.73-88.6c-.08-.63-.63-1.1-1.27-1.1h-21.54c-.64,0-1.19,.47-1.27,1.1l-11.73,88.6c-.09,.7,.4,1.33,1.1,1.42,.06,0,.11,.01,.17,.01Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.52,444.53c.63,0,1.18-.47,1.27-1.1l11.59-87.5h19.29l11.59,87.5c.09,.69,.72,1.19,1.44,1.09,.7-.09,1.2-.73,1.1-1.42l-11.73-88.6c-.08-.63-.63-1.1-1.27-1.1h-21.54c-.64,0-1.19,.47-1.27,1.1l-11.73,88.6c-.09,.7,.4,1.33,1.1,1.42,.06,0,.11,.01,.17,.01Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.23,354.65h-42.65c-8.14,0-14.79-6.46-14.96-14.52l-1.59-64.25c-.12-6.05,4.79-11.02,10.89-11.02h26.74c5.54,0,10.2,4.12,10.83,9.58l10.74,80.22Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.69,344.71h51.11c4.01,0,7.27,3.26,7.27,7.27v.02c0,1.46-1.19,2.65-2.65,2.65h-55.73v-9.94h0Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "234.97 450.12 263.19 450.12 268.73 389.19 229.44 389.19 234.97 450.12",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.67,399.33c.78-25.42-5.46-77.88-15.61-98.26l.69-.34c10.54,21.23,16.44,73.42,15.72,98.63l-.8-.02Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.69,317.83c-9.54,7.48-12.12,31.89-12.12,31.89,6.76-11.18,17.23-16.48,12.12-31.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.45,350.09c-.17-.06-.28-.23-.26-.41,.1-1.01,2.7-24.66,12.26-32.16,.1-.08,.23-.1,.35-.06,.12,.04,.22,.13,.26,.25,3.84,11.57-.93,17.51-6.45,24.39-2.08,2.47-3.99,5.09-5.71,7.82-.07,.12-.2,.19-.34,.19l-.12-.02Zm.73-2.07c1.54-2.33,3.2-4.4,4.82-6.42,5.29-6.6,9.87-12.31,6.49-23.12-7.52,6.44-10.56,23.95-11.31,29.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.27,313.93c11.43,3.97,21.57,26.54,21.57,26.54-10.01-8.38-21.42-10.33-21.57-26.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.88,340.78c-2.43-1.97-4.99-3.8-7.64-5.46-7.48-4.87-13.94-9.09-14.05-21.41,0-.13,.06-.24,.16-.32,.1-.07,.24-.09,.36-.05,11.47,4,21.38,25.84,21.79,26.77,.03,.05,.04,.11,.04,.17,0,.21-.18,.38-.39,.38-.1,0-.19-.02-.27-.08Zm-7.2-6.11c2.1,1.37,4.25,2.77,6.38,4.43-2.47-5.04-10.86-20.92-20.08-24.62,.3,11.47,6.52,15.51,13.7,20.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.61,341.14c-11.85,8.98-15.75,42.93-15.75,42.93,8.52-13.53,21.68-23.94,15.75-42.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.7,384.52c-.21-.07-.34-.28-.32-.51,.16-1.4,4.07-34.26,15.94-43.24,.12-.09,.29-.12,.44-.08,.15,.05,.27,.16,.31,.31,4.73,15.13-2.39,24.75-9.93,34.94-1.97,2.69-4.06,5.48-5.88,8.37-.09,.14-.24,.22-.41,.22-.05,0-.11,0-.16-.02Zm.91-2.49c1.53-2.29,3.2-4.5,4.76-6.65,7.27-9.83,14.15-19.13,9.98-33.41-9.48,7.94-13.68,32.69-14.74,40.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.36,336.44c13.93,5.14,27.13,29.33,27.13,29.33-12.07-10.48-27.31-9.45-27.13-29.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.18,366.13c-3.73-3.24-7.72-5.34-11.58-7.38-8.5-4.48-15.84-8.35-15.72-22.31,0-.05,.01-.1,.03-.15,.09-.25,.37-.38,.62-.29,13.94,5.14,26.85,28.55,27.39,29.54,.11,.2,.06,.46-.12,.6-.08,.07-.19,.11-.3,.11-.11,0-.23-.04-.31-.12Zm-26.34-28.99c.13,12.82,7.13,16.51,15.24,20.77,3.4,1.68,6.66,3.64,9.74,5.85-3.61-5.96-14.09-22.13-24.98-26.62h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.73,302.79c-6.66,5.22-8.45,22.24-8.45,22.24,4.71-7.79,12.02-11.5,8.45-22.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.15,325.28c-.12-.04-.19-.16-.18-.28,.1-.7,1.92-17.2,8.59-22.44,.07-.05,.16-.07,.25-.05,.08,.03,.15,.1,.18,.18,2.68,8.07-.65,12.21-4.5,17.01-1.45,1.73-2.78,3.56-3.98,5.46-.05,.08-.13,.13-.23,.13-.04,0-.09,0-.12-.02Zm.55-1.43c1.08-1.62,2.23-3.08,3.36-4.48,3.69-4.6,6.87-8.58,4.53-16.12-5.24,4.51-7.34,16.71-7.89,20.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238,313.74c-1.7-1.37-3.48-2.64-5.33-3.8-5.22-3.4-9.73-6.35-9.81-14.93,0-.09,.04-.18,.12-.23,.08-.04,.17-.04,.25,0,8,2.8,14.91,18.03,15.2,18.68,.05,.12,.01,.25-.09,.33-.05,.04-.1,.06-.16,.05-.07,0-.14-.04-.18-.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M713.36,454.77c0,3.39-151.49,6.13-338.36,6.13s-338.36-2.75-338.36-6.13,151.49-6.13,338.36-6.13,338.36,2.75,338.36,6.13Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character_3--inject-1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M520.99,256.94c.23,.08,6.58,9.21,6.58,9.21l8.29-6.76-5.68-4.9s-9.46,2.12-9.32,2.28",
    style: {
      fill: "#895555"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M530.47,254.8s1.63-3.33,.6-6.22c-1.03-2.89-1.08-5.47-2-7.56-.91-2.09-1.83,.85-2,2.52-.17,1.67-.38,3.55-1.61,3.22-1.23-.33-9-8.05-10.76-8.32-1.76-.26-.89,1.38-.89,1.38,0,0-1.76-1.72-2.87-1.25-1.11,.46-.34,1.88-.34,1.88,0,0-1.22-1.11-1.9-.16-.69,.95,4.58,8.15,4.64,8.6,0,0-2.09-4.66-3.57-4.34-1.48,.32,.16,3.23,1.42,5.58,1.26,2.35,3.33,4.43,5.86,5.43,2.53,1,6.25,4.01,8.97,2.45,2.73-1.56,4.44-3.2,4.44-3.2Z",
    style: {
      fill: "#895555"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M510.68,240.87c1.99,1.98,3.92,4.02,5.75,6.11-.54,.5-1.02,1.03-1.49,1.61-.22,.29,.3,.52,.52,.24,1.38-1.73,3.18-3.15,5.29-4.2,.34-.17,.05-.59-.3-.42-.53,.26-1.02,.54-1.51,.85,0-.05-.01-.1-.05-.14-1.31-1.74-2.83-3.33-4.57-4.76-.27-.21-.7,.16-.42,.39,1.7,1.4,3.2,2.94,4.47,4.65,.05,.06-.64,.59-.56,.59-.61,.4-.44,.35-.97,.82-1.83-2.09-3.75-4.13-5.75-6.11-.24-.24-.66,.14-.42,.38Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M519.7,247.91c3.21,.89,5.22,3.33,5.25,6.28,0,.33,.6,.31,.6-.02-.03-3.2-2.23-5.79-5.68-6.76-.36-.09-.51,.4-.17,.5Z"
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "M576.47,234.34s-9.1-3.41-12.25,7.29c-4.49,9.66-10.14,25.9-12.57,32.97l-18.93-20.16-10.47,8.25,18.21,26.13c4.84,6.95,14.37,8.89,21.43,4.21,.69-.46,2.78-4.01,2.9-4.3l6.47-12.56c14.52-25.34,11.33-37.93,5.21-41.83Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M625.73,284.07s-3.11,62.43-16.56,73.18h14.38s12.82-21.27,13.78-73.18h-11.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.92,352.08h74.57v5.85c0,2.48-2.01,4.49-4.49,4.49h-65.59c-2.48,0-4.49-2.01-4.49-4.49v-5.85h0Z",
    transform: "translate(1198.4 714.5) rotate(180)",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.92,352.08h74.57v5.85c0,2.48-2.01,4.49-4.49,4.49h-65.59c-2.48,0-4.49-2.01-4.49-4.49v-5.85h0Z",
    transform: "translate(1198.4 714.5) rotate(180)",
    style: {
      isolation: "isolate",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.67,434.05l-28.75-2.51v-45.25h-10.11v45.24l-28.85,2.52c-2.54,.25-4.48,2.39-4.48,4.94v3.83h76.66v-3.83c0-2.55-1.94-4.69-4.48-4.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.79,447.57c0,3.65-2.96,6.61-6.61,6.61s-6.61-2.96-6.61-6.61,2.96-6.61,6.61-6.61,6.61,2.96,6.61,6.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.84,447.57c0,3.65,2.96,6.61,6.61,6.61s6.61-2.96,6.61-6.61-2.96-6.61-6.61-6.61-6.61,2.96-6.61,6.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.3,358.76h13.59v28.42c0,2.05-1.66,3.71-3.71,3.71h-6.16c-2.05,0-3.71-1.66-3.71-3.71v-28.42h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.3,358.76h13.59v28.42c0,2.05-1.66,3.71-3.71,3.71h-6.16c-2.05,0-3.71-1.66-3.71-3.71v-28.42h0Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 559.08,
    y: 357.25,
    width: 80.25,
    height: 5.17,
    rx: 1.81,
    ry: 1.81,
    transform: "translate(1198.4 719.67) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 559.08,
    y: 357.25,
    width: 80.25,
    height: 5.17,
    rx: 1.81,
    ry: 1.81,
    transform: "translate(1198.4 719.67) rotate(180)",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M644.03,297.74h-23.03c-6.75,0-11.62-6.06-10.89-13.54l.98-9.98c.74-7.48,6.8-13.54,13.55-13.54h23.03c6.75,0,11.62,6.06,10.89,13.54l-.98,9.98c-.74,7.48-6.8,13.54-13.55,13.54Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.03,297.74h-23.03c-6.75,0-11.62-6.06-10.89-13.54l.98-9.98c.74-7.48,6.8-13.54,13.55-13.54h23.03c6.75,0,11.62,6.06,10.89,13.54l-.98,9.98c-.74,7.48-6.8,13.54-13.55,13.54Z",
    style: {
      isolation: "isolate",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "639.12 260.67 631.71 297.74 624.71 297.74 630.3 260.67 639.12 260.67",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "636.78 297.74 636.46 302.21 624.27 302.21 624.71 297.74 636.78 297.74",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "509.88 409.8 508.26 435.45 497.15 437.11 494.92 409.26 509.88 409.8",
    style: {
      fill: "#895555"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M506.04,433.9c-1.49,1.38-3.41,1.43-4.86,.3l-.3-2.07c-.26-1.78-1.32-2.91-3.23-2.67-.94,.12-2.22,1.16-3,2.86-1.39,3.05-3.56,4.37-3.56,4.37,0,0-8.54,4.25-11.6,5.18-1.83,.56-4.27,1.4-5.58,3.36-.37,.56-.71,1.22-1,2-.24,.64-.23,2.09-.23,2.13h21.64s2.21-1.3,3.15-1.26c1.67,.06,2.42,1.51,2.42,1.51l7.87,.05s.15-1.21,.37-2.98h0c.1-.8,.21-1.7,.33-2.66,.51-4.11,1.3-9.3,1.44-10.47,.23-2.04-3.83,.34-3.83,.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.48,438.78c.1-.09,.25-.1,.36-.03,.52,.32,.95,.78,1.24,1.35,.15,.3-.32,.58-.47,.28-.26-.51-.64-.91-1.09-1.19-.15-.09-.17-.29-.04-.41h0Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.15,437.88c.1-.09,.25-.1,.36-.03,.52,.32,.95,.78,1.24,1.35,.15,.3-.32,.58-.47,.28-.26-.51-.64-.91-1.09-1.19-.15-.09-.17-.29-.04-.41h0Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.87,437.04c.1-.09,.25-.1,.36-.03,.52,.32,.95,.78,1.24,1.35,.15,.3-.32,.58-.47,.28-.26-.51-.64-.91-1.09-1.19-.15-.09-.17-.29-.04-.41h0Z",
    style: {
      fill: "#2F8DE4"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M473.33,446.3c-.15,.31-.3,.64-.43,1-.24,.64-.23,2.09-.23,2.13h21.64s2.21-1.3,3.15-1.26c1.67,.06,2.42,1.51,2.42,1.51l7.87,.05s.15-1.21,.37-2.98h0c.02-.14,.04-.3,.05-.44h-34.83Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M490.23,437.65l-.27-.22c-.41-.34-1.79-1.49-2.14-2.2-.36-.73-.42-1.54-.18-2.21,.14-.38,.46-.8,.93-.83,.35-.02,.71,.2,1.01,.61,.41,.58,.66,1.33,.74,2.21,.07,.77,0,1.54-.06,2.29l-.03,.35Zm-1.61-5.09h-.03c-.29,.02-.51,.33-.6,.59-.21,.57-.15,1.27,.16,1.91,.22,.46,1.02,1.22,1.77,1.86,.05-.62,.09-1.25,.03-1.87-.07-.82-.3-1.5-.68-2.03-.12-.17-.37-.46-.66-.46Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.86,437.54l.14-.32c.29-.69,.6-1.4,1.02-2.05,.48-.74,1.05-1.28,1.69-1.6,.46-.23,.88-.25,1.18-.07,.4,.25,.48,.76,.43,1.17-.1,.71-.53,1.38-1.19,1.86-.64,.47-2.4,.84-2.93,.94l-.34,.07Zm3.56-3.79c-.2,0-.41,.09-.55,.15-.58,.29-1.1,.79-1.55,1.47-.34,.52-.61,1.1-.85,1.67,.96-.2,2.02-.5,2.44-.8,.58-.42,.96-1.01,1.04-1.61,.04-.28,0-.65-.25-.8-.08-.05-.18-.07-.28-.07Z",
    style: {
      fill: "#2F8DE4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M508.42,432.84l1.46-23.04-14.95-.54,1.65,20.65c-.7,.47-1.43,1.3-1.93,2.41-.21,.46-.44,.88-.67,1.26-.03-.02-.04-.05-.08-.07-.3-.19-.72-.16-1.18,.07-.64,.32-1.21,.86-1.69,1.6-.27,.42-.49,.86-.7,1.31,.03-.48,.04-.97,0-1.46-.08-.88-.33-1.62-.74-2.21-.3-.42-.66-.63-1.01-.61-.47,.03-.78,.45-.93,.83-.25,.67-.18,1.47,.18,2.21,.31,.64,1.46,1.64,1.99,2.08h0c-.35,.18-.76,.38-1.22,.6-.03-.02-.05-.04-.07-.05-.11-.07-.26-.06-.36,.03h0c-.08,.08-.1,.18-.07,.27-.4,.19-.82,.39-1.26,.6-.11-.06-.24-.05-.34,.03h0c-.05,.05-.07,.11-.08,.16-2.51,1.17-5.39,2.46-6.92,2.93-1.83,.56-4.27,1.41-5.58,3.36-.37,.56-.71,1.22-1,2-.24,.64-.23,2.09-.23,2.13h0v.06h21.64s2.21-1.3,3.15-1.26c1.67,.06,2.42,1.51,2.42,1.51l7.87,.05s.15-1.21,.37-2.98h0l.05-.44h0c.09-.7,.18-1.47,.28-2.28,.51-4.12,1.3-9.3,1.44-10.47,.1-.89-.61-.94-1.45-.71Zm-17.09,2.53c.45-.68,.97-1.18,1.55-1.47,.13-.07,.34-.15,.55-.15,.1,0,.19,.02,.28,.07,.03,.02,.05,.05,.07,.07-1.28,1.94-2.69,2.8-2.69,2.8,0,0-.21,.11-.58,.29,.24-.55,.5-1.1,.82-1.6Zm-3.18-.3c-.32-.64-.37-1.34-.16-1.91,.1-.26,.31-.57,.6-.59h.03c.29,0,.54,.28,.66,.46,.38,.53,.6,1.21,.68,2.03,.06,.62,.02,1.25-.03,1.87-.75-.63-1.55-1.4-1.77-1.86Z",
    style: {
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "530.39 409.8 528.77 435.45 517.66 437.11 515.44 409.26 530.39 409.8",
    style: {
      fill: "#895555"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M526.55,433.9c-1.49,1.38-3.41,1.43-4.86,.3l-.3-2.07c-.26-1.78-1.32-2.91-3.23-2.67-.94,.12-2.22,1.16-3,2.86-1.39,3.05-3.56,4.37-3.56,4.37,0,0-8.54,4.25-11.6,5.18-1.83,.56-4.27,1.4-5.58,3.36-.37,.56-.71,1.22-1,2-.24,.64-.23,2.09-.23,2.13h21.64s2.21-1.3,3.15-1.26c1.67,.06,2.42,1.51,2.42,1.51l7.87,.05s.15-1.21,.37-2.98h0c.1-.8,.21-1.7,.33-2.66,.51-4.11,1.3-9.3,1.44-10.47,.23-2.04-3.83,.34-3.83,.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.99,438.78c.1-.09,.25-.1,.36-.03,.52,.32,.95,.78,1.24,1.35,.15,.3-.32,.58-.47,.28-.26-.51-.64-.91-1.09-1.19-.15-.09-.17-.29-.04-.41h0Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.66,437.88c.1-.09,.25-.1,.36-.03,.52,.32,.95,.78,1.24,1.35,.15,.3-.32,.58-.47,.28-.26-.51-.64-.91-1.09-1.19-.15-.09-.17-.29-.04-.41h0Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.39,437.04c.1-.09,.25-.1,.36-.03,.52,.32,.95,.78,1.24,1.35,.15,.3-.32,.58-.47,.28-.26-.51-.64-.91-1.09-1.19-.15-.09-.17-.29-.04-.41h0Z",
    style: {
      fill: "#2F8DE4"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M493.84,446.3c-.15,.31-.3,.64-.43,1-.24,.64-.23,2.09-.23,2.13h21.64s2.21-1.3,3.15-1.26c1.67,.06,2.42,1.51,2.42,1.51l7.87,.05s.15-1.21,.37-2.98h0l.05-.44h-34.83Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M510.74,437.65l-.27-.22c-.41-.34-1.79-1.49-2.14-2.2-.36-.73-.42-1.54-.18-2.21,.14-.38,.46-.8,.93-.83,.35-.02,.72,.2,1.01,.61,.41,.58,.66,1.33,.74,2.21,.07,.77,0,1.54-.06,2.29l-.03,.35Zm-1.61-5.09h-.03c-.29,.02-.51,.33-.6,.59-.21,.57-.15,1.27,.16,1.91,.22,.46,1.02,1.22,1.77,1.86,.05-.62,.09-1.25,.03-1.87-.07-.82-.3-1.5-.68-2.03-.12-.17-.37-.46-.66-.46Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.37,437.54l.14-.32c.29-.69,.6-1.4,1.02-2.05,.48-.74,1.05-1.28,1.69-1.6,.46-.23,.88-.25,1.18-.07,.4,.25,.48,.76,.43,1.17-.1,.71-.53,1.38-1.19,1.86-.64,.47-2.4,.84-2.93,.94l-.34,.07Zm3.56-3.79c-.2,0-.41,.09-.55,.15-.58,.29-1.1,.79-1.55,1.47-.34,.52-.61,1.1-.85,1.67,.96-.2,2.02-.5,2.44-.8,.58-.42,.96-1.01,1.04-1.61,.04-.28,0-.65-.25-.8-.08-.05-.18-.07-.28-.07Z",
    style: {
      fill: "#2F8DE4"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--_Group_--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M574.18,319.35s-52.7,4.53-72.83,11.71c-2.91,1.04-4.8,2.47-6.43,4.39-9.39,11.04-6.81,85.38-6.81,85.38l23.67,.99s-2.55-56.93,2.7-60.57c5.25-3.64,62.9-14.06,62.9-14.06l-1.08-28.43-2.13,.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.42,326.27l-45.04,.56c-9.94,.17-18.54,5.15-19.78,10.85l.24,32.05,1.43,52.08h23.56l.57-61.97,39.02-33.56Z",
    style: {
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.92,423.99l-1.49-54.26-.24-32.05c1.24-5.7,6.26-8.66,12.07-9.13l49.16-2.28,7.39-13.59,45.45,6.2s-.75,23.2-7.23,31.71c-5.07,6.66-75.79,7.52-81.03,9.25l.22,64.15h-24.29Z",
    style: {
      fill: "#263238"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M603.76,229.32s-1.54-6.54,1.28-18.37c0-.01-.63-.26-.63-.27,.39-1.66,.81-3.19,1.21-4.52,0-.04,0-.05,0-.05l-15.49,10.65c.56,3.71-.43,10.99-1.08,14.08,0,0-1.75,5.61,5.6,5.5,5.37-.08,9.09-7.01,9.09-7.01Z",
    style: {
      fill: "#895555"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M609.04,179.05s-4.77-10.89-18.07-6.37c-8.38,2.85-14.33,6.59-13.45,14.16,.59,5.03,5.45,8.78,8.54,8.57,3.09-.22,25.63-8.01,25.63-8.01,0,0,5.07-6.21-2.66-8.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M598.47,219.44c-1.92,2.2-5.26,3.43-8.31,3.5,.04-.27,.04-.68,.07-.95,.05-.43,.05-1.08,.07-1.53,.02-.55,.03-1.15,0-1.72-.03-.23-.12-.19-.14-.42l-.05-.46,9.26-3.14c.75,.55,.65,2.94-.9,4.72Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M611,196.71c2.22-9.95-6.42-19.1-16.74-16.71-10.47,2.43-14.22,17.12-13.5,26.49,.8,10.41,12.46,16.99,21.33,10.45,5.9-4.35,6.69-10.28,8.91-20.23h0Z",
    style: {
      fill: "#895555"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.85,181.1s-8.87,8.25-17.53,3.99c-8.66-4.26,10.45-12.78,17.53-3.99Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.08,200.24c1.62,1.87,3.02-.03,6.86-2.07,.53-.28,1.11-.5,1.91-.52-.9,3.33-1.77,6.09-2.47,8.07-.21,.59-.44,1.14-.68,1.64,2.98-3.57,6.39-7.82,7.47-9.75,.22-.39,.39-.77,.52-1.13-.06-.13-.12-.27-.18-.39-.27-.57-.62-1.08-1.02-1.56-.63-.75-1.4-1.41-2.25-1.97-2.76-1.83-5.87-2.64-8.51-3.07-.26,3.16-2.96,9.23-1.64,10.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.4,183.58s2.4,1.97,2.37,4.37c-.03,2.4-.75,4.86-.75,4.86,0,0,7.29,2.27,9.09,1.77,1.8-.5,2.68-5.76,2.68-5.76,0,0-8.98-8.7-12.16-8.15-3.19,.55-1.23,2.91-1.23,2.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.74,180.66s4.12-1.14,6.9,3.16c2.78,4.3,1.69,9.81,.04,12.66-1.65,2.85-11.84-6.2-6.94-15.82Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M613.78,203.94c-1.08,2.63-3.28,4.5-5.45,5.36-3.27,1.28-4.14-2.25-3.55-5.53,.53-2.95,1.72-6.51,5.16-6.38,3.39,.12,5.07,3.55,3.84,6.56Z",
    style: {
      fill: "#895555"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.61,198.91c-.09,1.04-.72,1.82-1.39,1.76-.68-.07-1.15-.96-1.06-2,.09-1.04,.72-1.82,1.39-1.76,.68,.07,1.15,.96,1.06,2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.56,198.23c-.09,1.04-.72,1.82-1.39,1.76-.68-.07-1.15-.96-1.06-2,.09-1.04,.72-1.82,1.39-1.76,.68,.07,1.15,.96,1.06,2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.55,196.99s-3.74,4.86-4.98,6.87c1.33,1.43,3.87,1.05,3.87,1.05l1.11-7.92Z",
    style: {
      fill: "#773737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.27,193.3c-.16,.05-.35,.01-.48-.11-1.56-1.45-3.19-1.12-3.36-1.09-.26,.06-.53-.1-.59-.36-.07-.26,.1-.52,.36-.59,.09-.02,2.29-.52,4.26,1.32,.2,.18,.21,.49,.03,.69-.06,.06-.13,.11-.21,.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.56,203.8s-.03,0-.05,0c-.14-.03-.22-.16-.2-.29,.19-.94,.63-1.82,1.26-2.54,.43-.49,1.13-1.1,2.06-1.24,.91-.14,1.82,.26,2.22,.98,.07,.12,.02,.27-.1,.34-.12,.07-.27,.02-.34-.1-.29-.53-1-.83-1.7-.73-.78,.12-1.39,.65-1.76,1.08-.58,.65-.97,1.45-1.15,2.31-.02,.12-.13,.2-.25,.2Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.02,192.5c-.09-.03-.17-.08-.23-.16-.17-.21-.14-.52,.06-.69,2.07-1.71,4.21-1.03,4.31-1.01,.26,.08,.4,.36,.32,.61-.08,.26-.35,.4-.6,.32-.09-.03-1.74-.53-3.4,.84-.13,.11-.3,.13-.45,.09Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M595.89,207.07s-2.5,1.56-6.89,1.56c0,0,.8,3.01,3.61,2.76,3.4-.3,3.28-4.32,3.28-4.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.72,205.76c-1.61,.05-3.18,.6-4.38,1.68-.46,.42-.85,.89-1.01,1.41-.51,1.63,5.28,.49,7.66-.42,2.38-.91,1.83-1.84,.49-2.39-.64-.26-1.76-.3-2.75-.27Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M603.56,190.27s4.23,2.72,8.46,1.94c4.23-.78,5.32-1.71,5.32-1.71l-.31,2.3s-3.57,2.1-7.94,1.86c-4.37-.24-6.22-1.33-6.22-1.33l.68-3.06Z",
    style: {
      fill: "#fff",
      opacity: 0.3
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M579.6,231.99c5.1-.32,26.15-.68,46.99,3.5l-4.85,69.96s-4.83,5.36-9.24,14.84c-41.25,10.22-46.78,2.77-46.78-3.95,0-.11-1.78,5.71-.43-7.07,2.39-22.52,4.99-54.7,8.7-74.95,.1-.5,5.09-2.29,5.6-2.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M596.93,312.46s-6.48,33.19-4.42,36.24c2.06,3.05,19.46,3.36,19.46,3.36,0,0,2.67-.92,3.43-3.21l-18.47-36.39Z",
    style: {
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.97,274.88c1.2-20.96,7.7-45.61,7.7-45.61,16.9,5.03,17.92,5.5,17.92,5.5,0,0,1.24,19.8,1.09,36.06,0,5.23-4.96,30.05-4.96,33.79l7.55,43.9c-.17,3.51-27.53,.73-35.99-.19-2.86-.36,5.5-52.5,6.7-73.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.41,320.45s9.67-1.9,11.21-33.9c1.67-34.59,10.52-57.06,10.52-57.06,.35-.08-19.02,5.2-19.02,5.2-1.37,3.92-5.75,73.98-5.75,73.98l-4.87,13.39,7.9-1.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.82,224.14l6.77,5.54,1.35,10.7c.16,3.65-.99,7.24-3.24,10.12l-1.63,2.09,2.91,2.5c.92,.79,1.26,2.06,.86,3.21l-9.12,25.7h0c.18-6.76-.34-18.92,2.23-36.75,.96-7.01-.25-15.46-.12-23.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.82,224.14l6.77,5.54,1.35,10.7c.16,3.65-.99,7.24-3.24,10.12l-1.63,2.09,2.91,2.5c.92,.79,1.26,2.06,.86,3.21l-9.12,25.7h0c.18-6.76-.34-18.92,2.23-36.75,.96-7.01-.25-15.46-.12-23.12Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.02,229.27s-3.41,3.13-5.39,10.53c-1.98,7.4-6.83,39.98-6.93,44.09l-.41-.33-3.29-28.27c.2-1.39,.99-2.62,2.17-3.39l3.17-2.07h0c-2.18-3.15-2.68-7.16-1.36-10.75,1.28-3.47,2.87-7.39,3.84-8.42,2.17-2.1,6.23-4.25,8.97-5.69l-.77,4.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "596.31 239.5 593.78 243.3 590.47 243.12 589.56 238.75 593.55 234.49 596.31 239.5",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "594.15 243.01 590.98 312.94 583.28 322.7 576.53 310.93 591.91 242.71 594.15 243.01",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "594.17 242.71 589.23 312.86 581.36 322.7 576.28 311.2 590.35 242.52 594.17 242.71",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.02,229.27s-3.41,3.13-5.39,10.53c-1.98,7.4-6.83,39.98-6.93,44.09l-.41-.33-3.29-28.27c.2-1.39,.99-2.62,2.17-3.39l3.17-2.07h0c-2.18-3.15-2.68-7.16-1.36-10.75,1.28-3.47,2.87-7.39,3.84-8.42,2.17-2.1,6.23-4.25,8.97-5.69l-.77,4.3Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M603.35,239.79l-5.88,3.51-4.12-7.42-4.59,5.37-.8-7.83s2.27,4.36,2.34,4.17c.06-.19,3.01-2.91,3.01-2.91l5.52,3.55,4.36-2.43c-.01,.05,.16,3.98,.16,3.98Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.81,225.17l-8.7,6.64-3.32-6.84-3.05,7.3,1.4,7.59,4.4-5.37s4.03,7.25,4.36,7.39c.33,.14,5.28-5.99,5.28-5.99l-.38-10.72Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M636.5,256.78l-15.88-1.76,.63,14.91,1.77,15.86-17.19,2.73-1.55,14.67s17.94,1.21,24.78,.45c3.44-.38,11.96-2.56,11.96-11.49,0-12.83-3-24.28-4.53-35.37Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.51,291.85l-3.56-3s-3.74-1.33-5.77-1.34c-1.57,0-1.83,1.36-1.07,2.74,0,0-3.95-.08-4.62,.2-.3,.12-1.14,.61-1.36,2.54-.22,1.92,2.28,2.85,2.28,2.85,0,0-.5,.55-.36,2.19,.14,1.64,2.24,1.54,2.12,1.75-.11,.21-.01,1.29,.15,2.26,.16,.97,1.22,1.4,3.23,1.33,2.01-.08,9.81-1.68,10.5-2.33,0,0,4.22,.52,4.4,.55,.19,.03,.59-8.08,.59-8.08l-6.53-1.66Z",
    style: {
      fill: "#895555"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.31,291.72l20.73-2.79-2.96-19h0l-2.46-14.91,2.6-20.94s10.24,.35,12.7,11.76c.56,2.59,1.81,6.57,2.41,10.94h0c1.52,11.09,4.53,22.54,4.53,35.37,0,8.92-8.52,11.1-11.96,11.49-6.84,.76-26.61-.45-26.61-.45l1.02-11.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.09,288.86s5.23,1.46,6.92,7.17c0,0,.61-2.36-1.35-5.44-1.96-3.08-6.18-4.21-6.18-4.21l.6,2.47Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M458.67,344.82v59.41c0,.48,.75,.48,.75,0v-59.41c0-.48-.75-.48-.75,0h0Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 456.44,
    y: 302.53,
    width: 218.41,
    height: 9.77,
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.02,
    y: 312.3,
    width: 202.24,
    height: 142.48,
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.02,
    y: 312.3,
    width: 202.24,
    height: 142.48,
    style: {
      isolation: "isolate",
      opacity: 0.3
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 456.44,
    y: 302.53,
    width: 218.41,
    height: 9.77,
    style: {
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate",
      opacity: 0.5
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M517.92,381.4c-1.94-.51-3.52-1.19-4.73-2.04l2.37-5.32c1.14,.75,2.46,1.36,3.97,1.82,1.5,.46,2.99,.69,4.44,.69,2.77,0,4.15-.69,4.15-2.08,0-.73-.39-1.27-1.18-1.62-.79-.35-2.06-.72-3.8-1.11-1.92-.41-3.52-.86-4.81-1.33-1.29-.47-2.39-1.23-3.31-2.28-.92-1.04-1.38-2.45-1.38-4.22,0-1.55,.42-2.95,1.27-4.21,.85-1.25,2.12-2.24,3.8-2.97,1.69-.73,3.76-1.09,6.21-1.09,1.67,0,3.33,.19,4.95,.56,1.63,.38,3.06,.93,4.3,1.66l-2.22,5.35c-2.43-1.31-4.78-1.97-7.06-1.97-1.43,0-2.48,.21-3.13,.64-.66,.42-.98,.98-.98,1.66s.39,1.19,1.17,1.53c.78,.34,2.03,.69,3.75,1.06,1.94,.41,3.55,.86,4.82,1.33,1.27,.47,2.38,1.23,3.31,2.26,.93,1.03,1.4,2.43,1.4,4.2,0,1.53-.42,2.91-1.27,4.15-.85,1.24-2.12,2.23-3.82,2.97-1.7,.74-3.76,1.11-6.19,1.11-2.06,0-4.07-.25-6.01-.76Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M556.97,363.78c1.49,1.46,2.24,3.65,2.24,6.59v11.29h-6.92v-10.16c0-2.69-1.08-4.04-3.24-4.04-1.19,0-2.14,.39-2.86,1.16-.72,.78-1.07,1.94-1.07,3.5v9.54h-6.92v-27.01h6.92v9.1c.75-.7,1.64-1.24,2.66-1.6,1.02-.36,2.11-.55,3.28-.55,2.45,0,4.42,.73,5.92,2.18Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M568.02,380.67c-1.7-.87-3.03-2.09-3.99-3.64-.96-1.55-1.44-3.31-1.44-5.28s.48-3.69,1.44-5.24c.96-1.55,2.28-2.76,3.97-3.62,1.69-.86,3.6-1.29,5.73-1.29s4.05,.43,5.75,1.29c1.7,.86,3.02,2.06,3.97,3.6,.95,1.54,1.42,3.29,1.42,5.26s-.47,3.73-1.42,5.28c-.95,1.55-2.27,2.77-3.97,3.64-1.7,.87-3.62,1.31-5.75,1.31s-4.02-.44-5.72-1.31Zm8.7-5.44c.78-.84,1.16-2,1.16-3.48s-.39-2.6-1.16-3.42c-.78-.82-1.77-1.24-2.99-1.24s-2.21,.41-2.99,1.24c-.78,.83-1.16,1.97-1.16,3.42s.39,2.64,1.16,3.48c.78,.84,1.77,1.26,2.99,1.26s2.21-.42,2.99-1.26Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M620.22,361.92l-7.03,19.73h-6.7l-3.71-10.74-3.86,10.74h-6.7l-7.03-19.73h6.55l4.04,11.94,4.19-11.94h5.9l4.08,12.05,4.19-12.05h6.08Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate",
      opacity: 0.5
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M560.45,350.84h-2.99v-2.18h8.72v2.18h-2.98v7.55h-2.75v-7.55Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M576.86,348.65l-4.17,9.74h-2.71l-4.16-9.74h2.98l2.64,6.34,2.7-6.34h2.73Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M517.84,378.31c-1.94-.51-3.52-1.19-4.73-2.04l2.37-5.32c1.14,.75,2.46,1.36,3.97,1.82,1.5,.46,2.99,.69,4.44,.69,2.77,0,4.15-.69,4.15-2.08,0-.73-.39-1.27-1.18-1.62-.79-.35-2.06-.72-3.8-1.11-1.92-.41-3.52-.86-4.81-1.33-1.29-.47-2.39-1.23-3.31-2.28-.92-1.04-1.38-2.45-1.38-4.22,0-1.55,.42-2.95,1.27-4.2,.85-1.25,2.12-2.24,3.8-2.97,1.69-.73,3.76-1.09,6.21-1.09,1.67,0,3.33,.19,4.95,.56,1.63,.38,3.06,.93,4.3,1.66l-2.22,5.35c-2.43-1.31-4.78-1.97-7.06-1.97-1.43,0-2.48,.21-3.13,.64-.66,.42-.98,.98-.98,1.66s.39,1.19,1.17,1.53c.78,.34,2.03,.69,3.75,1.06,1.94,.41,3.55,.86,4.82,1.33,1.27,.47,2.38,1.23,3.31,2.26,.93,1.03,1.4,2.43,1.4,4.2,0,1.53-.42,2.91-1.27,4.15-.85,1.24-2.12,2.23-3.82,2.97-1.7,.74-3.76,1.11-6.19,1.11-2.06,0-4.07-.25-6.01-.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.88,360.69c1.49,1.46,2.24,3.65,2.24,6.59v11.29h-6.92v-10.16c0-2.69-1.08-4.04-3.24-4.04-1.19,0-2.14,.39-2.86,1.16-.72,.78-1.07,1.94-1.07,3.5v9.54h-6.92v-27.01h6.92v9.1c.75-.7,1.64-1.24,2.66-1.6,1.02-.36,2.11-.55,3.28-.55,2.45,0,4.42,.73,5.92,2.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.93,377.58c-1.7-.87-3.03-2.09-3.99-3.64-.96-1.55-1.44-3.31-1.44-5.28s.48-3.69,1.44-5.24c.96-1.55,2.28-2.76,3.97-3.62,1.69-.86,3.6-1.29,5.73-1.29s4.05,.43,5.75,1.29c1.7,.86,3.02,2.06,3.97,3.6,.95,1.54,1.42,3.29,1.42,5.26s-.47,3.73-1.42,5.28c-.95,1.55-2.27,2.77-3.97,3.64-1.7,.87-3.62,1.31-5.75,1.31s-4.02-.44-5.72-1.31Zm8.7-5.44c.78-.84,1.16-2,1.16-3.48s-.39-2.6-1.16-3.42c-.78-.82-1.77-1.24-2.99-1.24s-2.21,.41-2.99,1.24c-.78,.83-1.17,1.97-1.17,3.42s.39,2.64,1.17,3.48c.78,.84,1.77,1.26,2.99,1.26s2.21-.42,2.99-1.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.14,358.83l-7.03,19.73h-6.7l-3.71-10.74-3.86,10.74h-6.7l-7.03-19.73h6.55l4.04,11.94,4.19-11.94h5.9l4.08,12.05,4.19-12.05h6.08Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M560.37,347.75h-2.99v-2.18h8.72v2.18h-2.98v7.55h-2.75v-7.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.77,345.57l-4.17,9.74h-2.71l-4.16-9.74h2.98l2.64,6.34,2.7-6.34h2.73Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 470.21,
    y: 298.98,
    width: 47.37,
    height: 3.56,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 470.21,
    y: 298.98,
    width: 47.37,
    height: 3.56,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Speech_Bubble--inject-1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M520.88,162.4h23.75c6.09,0,11.03,4.94,11.03,11.03v13.31c0,6.09-4.94,11.03-11.03,11.03h-5.4l-.86,6.15-6.56-6.15h-10.93c-6.09,0-11.03-4.94-11.03-11.03v-13.31c0-6.09,4.94-11.03,11.03-11.03Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M527.15,180.13c0,1.57-1.27,2.84-2.84,2.84s-2.84-1.27-2.84-2.84,1.27-2.84,2.84-2.84,2.84,1.27,2.84,2.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.82,180.13c0,1.57-1.27,2.84-2.84,2.84s-2.84-1.27-2.84-2.84,1.27-2.84,2.84-2.84,2.84,1.27,2.84,2.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.75,180.13c0,1.57-1.27,2.84-2.84,2.84s-2.84-1.27-2.84-2.84,1.27-2.84,2.84-2.84,2.84,1.27,2.84,2.84Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M520.27,161h15.07c.48,0,.48-.75,0-.75h-15.07c-.48,0-.48,.75,0,.75h0Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.23,161h1.26c.2,0,.38-.17,.38-.38s-.16-.38-.38-.38h-1.26c-.2,0-.38,.17-.38,.38s.16,.38,.38,.38h0Z",
    style: {
      fill: "#2F8DE4"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M676.29,418.37c-.01-.42-1.44-42.55-8.29-49.21-6.66-6.48-14.31-.24-14.63,.03l-.69-.82c.09-.07,8.72-7.12,16.07,.03,7.16,6.96,8.56,48.19,8.62,49.94l-1.07,.03Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.88,426.65c-.05-.5-4.68-50.57,13.6-71.55l.81,.7c-17.98,20.64-13.39,70.24-13.34,70.74l-1.07,.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.2,421.35l-1.07-.07c.04-.57,3.58-56.92-9.83-69.25l.73-.79c13.79,12.68,10.33,67.77,10.18,70.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.95,421.32h-1.07c.01-1.56,.44-38.07,10.81-44.01,2.31-1.32,4.56-1.54,6.71-.65,6.27,2.59,9.38,13.75,9.51,14.23l-1.03,.28c-.03-.11-3.1-11.13-8.88-13.52-1.82-.75-3.76-.55-5.77,.59-9.84,5.64-10.27,42.71-10.27,43.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.91,421.35l-1.07-.06c.02-.29,1.56-28.85-6.14-38.91-1.87-2.44-3.9-3.6-6.04-3.45-5.05,.35-9.29,7.74-9.33,7.82l-.93-.53c.18-.32,4.56-7.97,10.19-8.36,2.52-.18,4.86,1.12,6.97,3.87,7.95,10.38,6.43,38.44,6.36,39.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.6,425.23c-.21-2.77-5.04-67.99,3.46-79.48l.86,.64c-8.26,11.17-3.3,78.09-3.25,78.76l-1.07,.08Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M698.25,380.25s-5.42,2-3.58,6.32c5.19,12.15,17.55,13.44,17.55,13.44,0,0,5.8-9.18,1.05-16.32-6.56-9.83-14.88-6.62-15.02-3.44Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.55,374.82s5.43-.23,5.74,4.45c.31,4.68-11.76,17.62-11.76,17.62,0,0-8.61-3.11-6.76-14.79,1.85-11.67,11.44-10.16,12.78-7.28Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.18,347.56s-2.28-.28-3.14-2.33c-2.56-6.12,6.23-12.72,17.98-9.23,0,0,.31,10.34-6.01,14.42-6.32,4.08-8.83-2.85-8.83-2.85Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.35,354.45s-.6,2.92-3.35,3.81c-8.18,2.66-15.78-9.4-10.03-24.22,0,0,13.4,.69,18,9.3,4.6,8.61-4.63,11.11-4.63,11.11Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.04,379.62s1.89-2.59-.97-2.85c-2.86-.25-15.23,5.29-11.98,17.98,0,0,15.91-5.19,16.47-10.5,.55-5.31-3.52-4.63-3.52-4.63Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.97,352.1s.71-2.36,3.41-3.34c2.7-.98,12.71-.37,12.85,12.73,0,0-15.4,2.56-17.31-2.43-1.91-4.99,1.05-6.96,1.05-6.96Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.66,362.98s1.04-1.8,3.01-.83c1.98,.96,7.81,6.96,2.25,14.21,0,0-10.34-6.22-9.49-10.58,.78-4.02,4.23-2.8,4.23-2.8Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.33,366.14s1.49-1.96-.69-2.2c-2.19-.24-11.99,2.37-9.7,12.16,0,0,11.94-.9,12.45-4.96,.51-4.06-2.05-5-2.05-5Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "694 454.79 659.75 454.79 656.06 417.29 697.69 417.29 694 454.79",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 654.23,
    y: 413.16,
    width: 45.29,
    height: 8.27,
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character_2--inject-1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M311.02,450.02c.66,0,1.22-.48,1.31-1.14l11.98-90.47h19.94l11.98,90.47c.1,.72,.75,1.23,1.49,1.13,.72-.09,1.24-.75,1.14-1.47l-12.13-91.61c-.09-.65-.65-1.14-1.31-1.14h-22.27c-.66,0-1.23,.49-1.31,1.14l-12.13,91.61c-.1,.72,.42,1.38,1.14,1.47,.06,0,.12,.01,.17,.01Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.51,450.02c.66,0,1.22-.48,1.31-1.14l11.98-90.47h19.94l11.98,90.47c.1,.72,.75,1.23,1.49,1.13,.72-.09,1.24-.75,1.14-1.47l-12.13-91.61c-.09-.65-.65-1.14-1.31-1.14h-22.27c-.66,0-1.23,.49-1.31,1.14l-12.13,91.61c-.1,.72,.42,1.38,1.14,1.47,.06,0,.12,.01,.17,.01Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.01,357.1h-44.1c-8.42,0-15.29-6.67-15.46-15.02l-1.64-66.43c-.13-6.25,4.95-11.39,11.26-11.39h27.64c5.73,0,10.54,4.26,11.19,9.9l11.11,82.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.01,357.1h-44.1c-8.42,0-15.29-6.67-15.46-15.02l-1.64-66.43c-.13-6.25,4.95-11.39,11.26-11.39h27.64c5.73,0,10.54,4.26,11.19,9.9l11.11,82.94Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.5,346.82h53.09c4.01,0,7.27,3.26,7.27,7.27v.36c0,1.46-1.19,2.65-2.65,2.65h-57.71v-10.28h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.5,346.82h53.09c4.01,0,7.27,3.26,7.27,7.27v.36c0,1.46-1.19,2.65-2.65,2.65h-57.71v-10.28h0Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M334,191.63c5.96,3.98,7.66,9.69,7.58,13.83-.74,5.59-2.68,9.54-4.19,14.97l-14.82-32.71c3.46,.69,5.02-.02,11.42,3.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.57,188.74c-5.8-2.7-11.5,.49-14.82,2.7-3.63,3.08-5.78,7.57-5.89,12.34,0,4.45,0,9.85,2.7,12.18,1.51,1.34,3.52,1.99,5.53,1.78l22.03-20.33c-2.4-3.65-5.69-6.64-9.56-8.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M326.95,248.96c-1.69,1.75-3.24,1.16-5.5,.24-13.45-4.84-9.47-11.33-9.47-11.33,2.55-2.99,2.66-6.58,1.73-12.04-.02-.16-.03-.32-.02-.48,0-.73,.24-1.44,.67-2.03,1.12-1.64,3.37-2.07,5.01-.94h0l6.02,1.72h0c.02,.08,.03,.17,.05,.26,.02,2.99-.07,5.3-.05,7.13,.04,.22,0,.45,.01,.66h0c.04,.22,.03,.46,.03,.67,.14,2.5,4.37,6.17,6.09,7.04,1.04,.6,1.16,3.2-4.59,9.09Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.39,224.09h0c0,.09,.02,.18,.05,.27,.02,2.99-.07,5.3-.05,7.13-.01,.22,0,.44,.01,.66h0c.01,.23,.04,.46,.08,.69h0c-4.58-1.24-8.66-3.86-11.7-7.5h0c0-.72,.22-1.42,.62-2.02,1.11-1.65,3.35-2.1,5-1l5.98,1.76Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.16,205.08c.23,10.3,.1,14.65,4.99,20.24,7.37,8.4,19.71,6.16,22.55-3.95,2.48-9.1,1.74-24.38-7.97-29.11-9.71-4.73-19.79,2.51-19.57,12.82Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.6,213.9c1.04,2.22,2.91,3.72,4.69,4.33,2.68,.92,4.46-3.36,3.76-6.18-.63-2.54-3.18-4.4-5.89-4.09-2.67,.31-3.75,3.39-2.56,5.94Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.43,214.09h0c-.14,0-.25-.12-.25-.25,.02-.92-.34-1.84-.98-2.5-.64-.67-1.54-1.06-2.46-1.08-.14,0-.25-.12-.24-.26,0-.14,.11-.24,.25-.24h0c1.06,.02,2.08,.47,2.81,1.23,.73,.76,1.14,1.8,1.12,2.86,0,.14-.11,.25-.25,.25Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M322.58,209.52c-.04,1.1,.47,2.05,1.15,2.12,.68,.07,1.26-.76,1.3-1.86,.04-1.1-.47-2.05-1.15-2.12-.68-.07-1.26,.76-1.3,1.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.77,210.35c-.04,1.06,.48,1.98,1.16,2.06,.68,.07,1.26-.73,1.29-1.8,.04-1.06-.48-1.98-1.16-2.06-.68-.07-1.26,.73-1.29,1.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.74,205.52c.13,.03,.27,0,.38-.09,1.72-1.34,3.47-.67,3.49-.66,.26,.1,.54-.03,.62-.29,.08-.27-.06-.56-.32-.67-.09-.04-2.29-.88-4.42,.79-.21,.17-.24,.49-.07,.72,.08,.11,.2,.18,.32,.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.64,205.45c.11-.03,.2-.1,.26-.21,.11-.23,.02-.53-.2-.69-2.25-1.53-4.09-.67-4.16-.63-.22,.11-.29,.4-.17,.65,.13,.25,.4,.37,.62,.26,.07-.03,1.51-.68,3.3,.54,.12,.08,.24,.1,.36,.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.04,209.61s1.29,4.01,2.91,6.57c.28,.45,.03,1.05-.48,1.19-1.32,.36-2.77-.19-2.77-.19l.34-7.57Z",
    style: {
      fill: "#a24e3f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M323.49,207.67l2.42-.36s-1.45,1.66-2.42,.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.82,208.55l2.42-.36s-1.45,1.66-2.42,.36Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M329.03,220.01c-.85,.96-2,2.89-2,2.89-.19-.07-.39-.14-.58-.23-2.61-1.05-3.47-2.39-3.64-3.57-.09-.64,.04-1.24,.2-1.7,.19-.54,.44-.88,.44-.88,1.05,1.38,3.4,2.54,4.69,3.11,.53,.24,.88,.37,.88,.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.15,219.64l-.61,.84c-2.45-.99-4.05-2.02-4.51-3.07,.19-.54,.44-.88,.44-.88,1.05,1.38,3.4,2.54,4.69,3.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.45,222.67c-2.61-1.05-3.47-2.39-3.64-3.57,.87,.39,1.88,.96,2.66,1.74,.6,.59,.86,1.24,.97,1.83Z",
    style: {
      fill: "#de5753"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M312.73,207.59s5.88-6.72,6.07-12.47c0,0,21.05-4.67,19.11,13.5,0,0,4.55-15.71-12.65-18.28-17.2-2.56-20.75,19.9-12.95,27.73,.03-.08-3.22-6.26,.42-10.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.38,193.91c.4,4.69,4.53,8.16,9.21,7.76,4.69-.4,8.16-4.53,7.76-9.21-.38-4.41-4.06-7.79-8.48-7.79-4.89,.23-8.67,4.36-8.49,9.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.07,192.59c2.26,2.17,3.78,5.01,4.32,8.1,0,2.24-3.05,3.86-3.05,3.86l-3.73-4.89v4.29c-6.1-.67-9.63-3.91-11.72-8.58l3.4-6.07s8.75,1.54,10.77,3.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304,198.82c-.52,2.43-1.96,4.65-3.96,6.12,1.08,.09,2.18-.18,3.1-.75-.04,.88-.24,1.75-.57,2.56,2.47-2.06,3.93-5.27,3.84-8.48l-2.4,.55Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M424.5,420.48l-10.21,.29s-18.22-35.08-26.97-54.75c-10.34-23.24-8.06-30.73-11.16-30.87-5.72-.25-64.14,26.61-78.78,11.71-14.63-14.9,6.54-50.8,6.54-50.8,0,0,32.61-5.04,35.27,2.92,.65,2.35,2.07,4.78,2.41,7.2,.39,2.39,1.19,5.91,1.19,5.91h0c.77-.19,23.12-2.36,36.99-2.04,8.36,.19,15.8,5.27,19.12,12.94,12.54,28.91,25.59,97.49,25.59,97.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.67,350.46s2.39,0,39.36-1.67c0,0-5.08,11.99-6.49,36.68-.58,10.16,1.04,43.05-.23,57.61,.64,.91,7.44,3.92,11.58,.88,0,0,23.99-86.57,23.75-98.32-.24-11.75-13.86-15.21-13.86-15.21,0,0-26.24,15.21-54.11,20.02Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.06,340.77c5.06-2.04,10.03-4.29,14.9-6.75,8.45-4.26,18.84,1.22,19.63,10.65,.03,.31,.04,.63,.05,.96,.12,4.77-4.14,22.66-10.23,42.11,.16-1.15,.38-2.29,.66-3.42,6.05-24.29,9.08-36.91,6.05-42.79-2.04-3.65-5.27-6.49-9.16-8.04l-33.04,16.1c-18.2,.8-20.92,.83-21.24,.83,11.1-2.09,21.95-5.32,32.38-9.66Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M367.62,439.04c.04-.52-.41-.96-.94-.96h-3.11c-.78-.02-1.64,1.38-2.12,2-2.07,2.68-3.54,1.61-5.66-1.01-1.38-.19-1.79,1.38-1.91,1.81l-2.82,9.37c-.24,.78,.19,1.61,.97,1.86,.14,.04,.28,.07,.43,.07,4.21,.1,6.21,.15,11.45,.28l16.03,.39c4.37,.11,5.38-4.28,3.59-4.73-8.05-1.98-13.73-4.51-16.17-6.92-.34-.32,.18-1.19,.25-2.16Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.01,444.27s-.1-.01-.14-.04c-.12-.08-.15-.23-.07-.35,.71-1.07,1.9-1.79,3.17-1.94,.13-.01,.26,.08,.28,.22,.02,.14-.08,.26-.22,.28-1.13,.13-2.18,.77-2.81,1.72-.05,.07-.13,.11-.21,.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.26,445.67s-.1-.01-.14-.04c-.12-.08-.15-.23-.07-.35,.71-1.07,1.9-1.79,3.17-1.94,.14-.02,.26,.08,.28,.22,.02,.14-.08,.26-.22,.28-1.13,.13-2.18,.77-2.81,1.72-.05,.07-.13,.11-.21,.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.04,447.1s-.1-.01-.14-.04c-.12-.08-.15-.23-.07-.35,.71-1.07,1.9-1.79,3.17-1.94,.14-.01,.26,.08,.28,.22,.02,.14-.08,.26-.22,.28-1.13,.13-2.18,.77-2.81,1.72-.05,.07-.13,.11-.21,.11Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M424,413.64l-3.26,1.18c-.74,.27-1.29,.89-1.51,1.64-.96,3.25-2.72,2.79-5.64,1.11-1.36,.32-1.17,1.94-1.13,2.38l.76,9.76c.06,.82,.76,1.44,1.58,1.38,.15,0,.29-.04,.42-.09,3.96-1.43,5.84-2.1,10.77-3.88l15.09-5.44c4.11-1.48,3.47-5.93,1.64-5.71-8.23,1.06-14.43,.77-17.58-.6-.58-.23-.23-.68-1.14-1.71Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.05,418.81s-.04,0-.05,0c-.13-.03-.22-.16-.19-.3,.27-1.25,1.12-2.36,2.26-2.95,.12-.06,.27-.02,.34,.11,.06,.12,.02,.27-.11,.34-1.01,.53-1.76,1.5-2,2.62-.03,.12-.13,.2-.24,.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.63,419.17s-.04,0-.05,0c-.13-.03-.22-.16-.19-.3,.28-1.25,1.12-2.36,2.26-2.95,.12-.07,.27-.02,.34,.11,.06,.12,.02,.27-.11,.34-1.01,.53-1.76,1.5-2,2.62-.03,.12-.13,.2-.24,.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.62,419.55s-.04,0-.05,0c-.13-.03-.22-.16-.19-.3,.28-1.25,1.12-2.36,2.26-2.95,.12-.06,.27-.02,.34,.11,.06,.12,.02,.27-.11,.34-1.01,.53-1.76,1.5-2,2.62-.03,.12-.13,.2-.24,.2Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M348.64,311.5l-4.69,.45s-.39-3.23-.78-5.61c-.34-2.42-3-10.54-3.65-12.89-13.43,1.33-36.2,.53-36.2,.53,0,0-20.56,38.02-5.94,52.88,8.78,8.91,34.63,3.69,53.78-4.13l-2.51-31.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.95,310.66l-20.59,4.29s11.27-6.11,19.81-8.59c.39,2.43,.78,4.3,.78,4.3Z",
    style: {
      isolation: "isolate",
      opacity: 0.3
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M374.14,262.27c.11-1.81-5.25,8.56-5.25,8.56l-9.06-6.39,7.21-7.25s7.32,4.78,7.21,4.94",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.78,238.79c4.85,2.38,8.53,6.61,10.24,11.73,3.07,9.19,4.41,20.23,4.41,20.23l11.44-10.19,8.52,6.33s-11.2,16.97-18.73,23.58c-6.26,5.49-13.35-5.16-13.35-5.16l-3.08-46.8,.54,.27Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.66 299.55 313.2 338.13 291.13 335.5 291.13 331.53 315.66 299.55",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.99,300.51c-.86-9.79-4.34-27.72-10.32-46.56-1.95-6.13,5.01-12.9,5.01-12.9,0,0,4.49-.35,5.31-.45,.9-.11,1.83-.2,2.76-.28,6.99-.58,12.71-1,18.95-.65,1.57,.09,3.18,.22,4.76,.36,.51,.05,3.82,.1,4.31,.16,0,0,8.96,10.49,9.45,17.89,.26,4.14,2.26,5.92,2.04,15.81-.04,6.72-4.92,16.51-5.36,25.95l-36.9,.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.2,267.62c-.47-15.36-2.28-25.11-3.11-28.84-.22-.98-1.14-1.63-2.14-1.51l-5.93,1.25c-5.81,1.55-8.93,.71-12.16,5.03-.63,.84-1.15,7.27-1.1,8.15,.08,1.58,1.18,6.43,2.64,12.28,1.01,4.06,2.2,8.62,3.33,12.91,1.46,5.47,2.68,6.9,3.15,8.65l-15.05,44.4c-.42,1.19,.38,2.46,1.63,2.59l21.6,2.26c1.06,.11,2.01-.64,2.13-1.7,1.08-9.01,5.56-47.82,5.02-65.47Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.59,297.71s4.53-28.09,3.33-35.12c-1.21-7.03-11.68-24.07-11.68-24.07l-4.78-.33-5.66-2.29s13.06,15.76,16.27,27.13c2.11,7.48-2.1,31.12-1.61,36.82l2.43,11.8,6.01-.27-4.31-13.67Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.29,234.85s5.88,11.6,3.65,40.78l-9.76-20.98,3.53-5.73-4.69-9.37s5.02-3.23,7.12-4.93l.14,.23Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M313.29,234.85s5.88,11.6,3.65,40.78l-9.76-20.98,3.53-5.73-4.69-9.37s5.02-3.23,7.12-4.93l.14,.23Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M343.37,275.8s2.19-6.44,1.79-12.37c-.4-5.94-.49-10.37-.49-10.37l-6.74-4.98,.89-6.07s-3.25-2-6.27-4.04c-2.06-1.4-6.11-3.51-6.64-3.35,0,0,17.21,21.78,17.3,30.69,.08,8.59,.17,10.49,.17,10.49Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.37,275.8s2.19-6.44,1.79-12.37c-.4-5.94-.49-10.37-.49-10.37l-6.74-4.98,.89-6.07s-3.25-2-6.27-4.04c-2.06-1.4-6.11-3.51-6.64-3.35,0,0,17.21,21.78,17.3,30.69,.08,8.59,.17,10.49,.17,10.49Z",
    style: {
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.68,290.73l2.35-21.66,.87,22.37s-2.25-.11-3.22-.7Z",
    style: {
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.25,240.43l-4.63-6.36-2.2,3.78-9.13-5.5-1.13,2.27,3.24,9.52s8.11,3.32,8.54,3.32,5.32-7.03,5.32-7.03Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.46 240.73 328.57 245.41 323.86 240.73 320.65 246.23 315.87 243.88 320.97 247.92 323.92 241.89 329.32 246.98 330.46 240.73",
    style: {
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.24 284.96 303.4 264.26 301.98 286.8 323.36 295.49 305.24 284.96",
    style: {
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.78,240.73s-6.79,1.67-8.1,9.08c-1.31,7.42-3.04,44.49-1.56,46.84,1.48,2.35,42.79,15.63,42.79,15.63l4.42-11.47-31.21-15.1s.25-10.59,.51-18.85c.13-4.36,.27-8.07,.37-9.22,.28-3.31-7.23-16.91-7.23-16.91Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.65,302.6s12.99,3.12,16,5.71c1.34,1.15,1.3,3.03,1.3,3.03l-21.03,.94,3.73-9.68Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.66,300.92c.42,.16,18.28,6.51,18.28,6.51v2.24l-19.19-6.06,.91-2.69Z",
    style: {
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.65,299.93c-.13,0-.25-.11-.25-.24-.05-1.87-.1-3.78-.14-5.71-.39-17.22-.83-36.74-9.56-51.96-.07-.12-.03-.27,.09-.34,.12-.07,.27-.03,.34,.09,8.79,15.33,9.23,34.92,9.62,52.2,.04,1.93,.09,3.83,.14,5.71,0,.14-.1,.25-.24,.26h0Z",
    style: {
      opacity: 0.2
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M367.52,258.24s-1.76-2.81-1.12-5.47c.64-2.66,.44-4.96,1.06-6.91,.61-1.95,1.71,.58,2.01,2.05,.31,1.46,.67,3.12,1.74,2.71,1.06-.41,7.24-8.01,8.77-8.41,1.54-.4,.92,1.14,.92,1.14,0,0,1.55-1.81,2.43-1.39,.23,.11,.59,.73,0,1.67-1.3,2.1-4.25,6.37-4.25,6.37,.16-.25,4.18-5.26,4.88-5.93,.91-.88,1.79-.82,2.28-.28,.7,.78-4.07,7.16-4.09,7.57,0,0,2.62-3.76,3.97-3.62,1.34,.15-.18,2.61-1.94,4.52-1.61,1.75-4.3,5.62-6.11,7.24-2.23,2-4.17,2.85-6.75,1.72-2.57-1.13-3.83-2.98-3.83-2.98Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.24,248.38s-.1-.01-.14-.04c-.11-.08-.14-.23-.07-.35,1.07-1.58,2.22-3.14,3.42-4.61,.09-.11,.24-.12,.35-.04,.11,.09,.12,.25,.04,.35-1.19,1.46-2.34,3-3.4,4.57-.05,.07-.13,.11-.21,.11Z",
    style: {
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.21,253.1c-.08,0-.15-.04-.2-.1-1.4-1.96-3.41-3.5-5.66-4.36-.13-.05-.19-.19-.15-.32,.05-.13,.19-.19,.32-.15,2.34,.89,4.43,2.5,5.89,4.53,.08,.11,.05,.27-.06,.35-.04,.03-.09,.05-.15,.05Z",
    style: {
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.77,257.6c-.05,0-.11-.02-.15-.05-.11-.08-.13-.24-.05-.35,.57-.75,.87-1.72,.82-2.66-.04-.94-.43-1.88-1.06-2.57-.09-.1-.09-.26,.02-.35,.1-.09,.26-.09,.35,.02,.72,.79,1.14,1.82,1.19,2.89,.05,1.05-.29,2.14-.92,2.98-.05,.07-.12,.1-.2,.1Z",
    style: {
      opacity: 0.3
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character_1--inject-1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 182.51,
    y: 294.59,
    width: 4.38,
    height: 156.17,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.33,
    y: 294.59,
    width: 4.38,
    height: 156.17,
    transform: "translate(50.12 -17.15) rotate(7.52)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.19,
    y: 294.35,
    width: 4.38,
    height: 156.17,
    transform: "translate(-42.59 27.88) rotate(-6.8)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.51,
    y: 294.59,
    width: 4.38,
    height: 156.17,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.33,
    y: 294.59,
    width: 4.38,
    height: 156.17,
    transform: "translate(50.12 -17.15) rotate(7.52)",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.19,
    y: 294.35,
    width: 4.38,
    height: 156.17,
    transform: "translate(-42.59 27.88) rotate(-6.8)",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.6,
    y: 284.94,
    width: 38.18,
    height: 9.29,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.7,292.42c0,2.11-1.71,3.83-3.83,3.83s-3.83-1.71-3.83-3.83,1.71-3.83,3.83-3.83,3.83,1.71,3.83,3.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.53,292.42c0,2.11-1.71,3.83-3.83,3.83s-3.83-1.71-3.83-3.83,1.71-3.83,3.83-3.83,3.83,1.71,3.83,3.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166.12,
    cy: 292.42,
    r: 3.83,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.7,292.42c0,2.11-1.71,3.83-3.83,3.83s-3.83-1.71-3.83-3.83,1.71-3.83,3.83-3.83,3.83,1.71,3.83,3.83Z",
    style: {
      fill: "#fff",
      opacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.53,292.42c0,2.11-1.71,3.83-3.83,3.83s-3.83-1.71-3.83-3.83,1.71-3.83,3.83-3.83,3.83,1.71,3.83,3.83Z",
    style: {
      fill: "#fff",
      opacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166.12,
    cy: 292.42,
    r: 3.83,
    style: {
      fill: "#fff",
      opacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "260.14 174.47 238.84 186.7 238.84 211.01 261.17 218.69 260.14 174.47",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.46 180.35 200 180.35 205.3 183.88 218.24 183.88 218.24 211.72 212.36 211.72 201.77 218.39 206.08 218.39 206.08 223.68 202.75 227.41 165.69 227.41 163.01 221.2 157.46 221.12 157.46 218.39 160.6 218.39 160.6 212.11 157.46 212.11 157.46 180.35",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.22,176.42l-2.88,3.93h15.98v-2.02h25.19v-.98c0-1.6-1.29-2.89-2.89-2.89h-31.55c-1.52,0-2.95,.72-3.85,1.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.19,
    y: 186.35,
    width: 14.66,
    height: 24.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.49,
    y: 186.35,
    width: 3.95,
    height: 24.66,
    style: {
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "234.17 211.01 234.17 221.2 252.46 221.2 239.45 211.01 234.17 211.01",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "234.17 186.47 234.17 172.95 252.46 172.95 239.45 186.47 234.17 186.47",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.46 221.12 170.82 221.28 170.82 218.39 167.44 218.39 167.44 212.11 170.49 212.11 170.49 180.35 157.46 180.35 157.46 212.11 160.6 212.11 160.6 218.39 157.46 218.39 157.46 221.12",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.09,
    y: 183.6,
    width: 9.48,
    height: 9.48,
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.01 221.2 206.08 221.5 206.08 223.68 202.75 227.41 165.69 227.41 163.01 221.2",
    style: {
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.49 212.11 212.36 211.72 201.77 218.39 167.44 218.39 167.44 212.11 170.49 212.11",
    style: {
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.05,
    y: 227.41,
    width: 7.31,
    height: 57.7,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.05,
    y: 227.41,
    width: 7.31,
    height: 57.7,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.17,206.92h-5.93v-16.49h5.93c4.55,0,8.24,3.69,8.24,8.24h0c0,4.55-3.69,8.24-8.24,8.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.17,206.92h-5.93v-16.49h5.93c4.55,0,8.24,3.69,8.24,8.24h0c0,4.55-3.69,8.24-8.24,8.24Z",
    style: {
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.3 183.88 170.49 183.88 170.49 180.35 199.95 180.35 205.3 183.88",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "168.57 180.35 170.09 170.11 175.07 170.11 177.96 174.47 177.96 180.35 168.57 180.35",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.57 180.35 170.09 170.11 175.07 170.11 177.96 174.47 177.96 180.35 168.57 180.35",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.09 180.35 159.61 170.11 164.59 170.11 167.48 174.47 167.48 180.35 158.09 180.35",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.65 157.28 141.65 165.81 148.37 172.95 171.68 172.95 171.68 157.28 141.65 157.28",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.43,
    y: 158.65,
    width: 13.71,
    height: 13.68,
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.43 169.33 158.09 165.11 158.09 158.65 150.43 158.65 150.43 169.33",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.46 157.28 157.46 165.77 161.77 172.95 175.07 172.95 175.07 157.28 157.46 157.28",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.46 157.28 157.46 165.77 161.77 172.95 175.07 172.95 175.07 157.28 157.46 157.28",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 174.56,
    y: 188.88,
    width: 12.34,
    height: 5.01,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.04,
    y: 188.88,
    width: 5.01,
    height: 5.01,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.75,
    y: 188.88,
    width: 5.01,
    height: 5.01,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.56,
    y: 206.41,
    width: 43.68,
    height: 1.74,
    style: {
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "181.05 241.51 188.35 235.95 188.35 227.41 181.05 227.41 181.05 241.51",
    style: {
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.09 193.08 160.21 193.08 160.24 184.55 168.57 184.57 168.57 183.6 159.09 183.6 159.09 193.08",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 142.22,
    y: 227.01,
    width: 6.2,
    height: 18.04,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.32,
    y: 227.01,
    width: 36.82,
    height: 2.55,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.97,228.29c0,2.44-1.98,4.42-4.42,4.42s-4.42-1.98-4.42-4.42,1.98-4.42,4.42-4.42,4.42,1.98,4.42,4.42Z",
    style: {
      fill: "#263238"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M115.41,159.13c0,.88,.39,1.55,.94,1.64,.56,.09,1.07-.65,1.12-1.55,.05-.9-.37-1.55-.93-1.64-.56-.09-1.02,.7-1.13,1.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.76,159.01c.31,2.85,1.01,5.63,2.09,8.29-1.4,.51-2.95,.39-4.24-.34l2.15-7.95Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.81,156.3c-.11,.01-.23-.02-.33-.08-.2-.2-.2-.52,0-.72h0c1.03-1.29,2.63-2,4.27-1.89,.27,.02,.47,.27,.45,.54h0c-.05,.28-.29,.47-.57,.45h0c-1.31-.06-2.56,.52-3.36,1.55-.12,.13-.29,.19-.46,.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.87,172.3c-.19,.53-.43,1.05-.7,1.55-1.44,2.76-3.69,5.02-6.44,6.47-.69,.37-1.41,.69-2.15,.94-3.95,1.44-8.35,1.02-11.96-1.15-1.6-.97-3-2.25-4.1-3.76-4.65-6.33-3.67-12.72-2.77-23.65,.56-8.3,7.74-14.56,16.04-14,2.32,.16,4.58,.85,6.59,2.03,9.99,5.78,9.22,22.13,5.5,31.56Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.88,180.55c-.6,.32-1.22,.6-1.87,.82-3.43,1.25-7.24,.89-10.38-.99,.58-1.07,1.29-2.07,2.12-2.96,3.6,.05,7.12,1.13,10.12,3.13Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.66,180.67c1.78,7.06,13.65,11.28,13.65,11.28,0,0,8.13,2.68,8.12-.43-3.61-3.35-4.32-6.54-3.53-9.49,.55-1.8,1.45-3.47,2.65-4.91,.64-.82,1.33-1.61,2.06-2.35l-6.95-19.13c-2.69,7.85-9.6,20.12-15.99,25.04Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.98,135.56s1.73,.23,6.01,5.53c3.58,4.48,.36,5.44,2.16,10.81,1.8,5.37-2.26,9.79-2.26,9.79,0,0-3.1,4.8-7.2,3.89,0,0-3.95,3.62-4.01,7.93s-9.29-.73-15.41,2.25c0,0-5.54-2.8-8.13-12.78-1.01-4.36-1.19-8.88-.53-13.3,.5-4.67,2.86-8.95,6.54-11.88,6.35-5.48,19.96-6.75,22.84-2.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.88,162.89c.12,2.13,1.2,4.08,2.93,5.33,2.08,1.25,3.96-1.66,4.1-4.97,.11-2.93-.82-7.22-3.27-7-2.45,.22-4.12,3.62-3.76,6.64Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.61,132.76c-19.93,.96-21.28,15.99-20.4,25.58,0,0,3.39,4.71,15.88,3.87,12.49-.84,24.93-8.08,24.93-8.08,0,0-.89-22.31-20.4-21.37Zm-17.91,23.85s-.11-3.34,5.81-3.23,7.24,5.49,7.24,5.49c-8.15,1.4-12.72-2.04-13.05-2.26Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.45,149.72s9.67-3.81,12.69-2.2c3.01,1.61,1.26,4.12-6.97,7.06l-5.72-4.86Z",
    style: {
      fill: "#2F8DE4"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M66.49,425.89l-.02,19.63,9.87,.71,3.47-18.44c-4.51-3.01-8.96-3.73-13.32-1.9Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.81,443.46c-.97,2.59-1.03,13.19-1.03,13.19l20.92,.02c1.24-3.83-.68-6.45-3.12-6.8-1.05-.15-2.28-1.22-3.18-2.16,0-.12-1.29-6.01-2.08-6.29,0,0-.54-.61-1.01,0-.46,.61-.87,2.6-.87,2.6-3.27-4.05-6.47-3.51-9.63-.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.56,446.54c2.36-.87,4.9-.54,6.96,.91,.36,.25,.7-.34,.35-.59-2.2-1.54-4.97-1.9-7.49-.98-.41,.15-.23,.81,.18,.66h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.64,455.12h0l-20.61-.02c-.19,0-.34-.15-.34-.34,0-.19,.15-.34,.34-.34h0l20.61,.02c.19,0,.34,.15,.34,.34,0,.19-.15,.34-.34,.34Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M62.83,435.56l21.03,1.03c4.72-14.12,9.38-64.74,9.86-79.94,.58-18.16,7.62-63.74,1.39-73.22s-34.39-1.93-34.39-1.93c0,0,3.51,55.5,2.11,73.2-1.22,15.34-3.1,60.43,0,80.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.13 431.48 84.76 437.96 61.97 437.28 61.14 431.05 86.13 431.48",
    style: {
      fill: "#2F8DE4"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M109.07,423.33l-.02,22.15,9.5,.72,4.67-20.73c-3.81-2.83-8.24-4.22-14.14-2.14Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.05,443.51c-.97,2.59-1.03,13.19-1.03,13.19l24.03,.03c1.24-3.83-1.35-6.1-3.79-6.45-1.05-.15-4.72-1.57-5.62-2.51,0-.12-1.29-6.01-2.08-6.29,0,0-.54-.61-1.01,0-.46,.61-.87,2.6-.87,2.6-3.27-4.05-6.47-3.51-9.63-.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.79,446.59c2.36-.87,4.9-.54,6.96,.91,.36,.25,.7-.34,.35-.59-2.2-1.54-4.97-1.9-7.49-.98-.41,.15-.23,.81,.18,.66h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.04,455.17h0l-23.79-.03c-.19,0-.34-.15-.34-.34,0-.19,.15-.34,.34-.34h0l23.79,.03c.19,0,.34,.15,.34,.34,0,.19-.15,.34-.34,.34Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M104.83,435.56l20.85,1.03c2.54-15.63,12.74-72.55,11.9-83.45-1.02-13.32-13.1-70.97-17.59-75.41-4.49-4.44-37.37,7.08-37.37,7.08,0,0,13.51,49.57,24.16,71.01,2.21,4.45-3.67,60.73-1.96,79.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.06 431.96 127 437.96 103.83 436.59 103.36 430.31 128.06 431.96",
    style: {
      fill: "#2F8DE4"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.61,317.98c-.4-.81-.8-1.62-1.17-2.44-1.98-4.41-3.48-8.99-4.67-13.67-3.43-.34-6.82-1.03-10.12-2.08-.42-.13-.24-.79,.18-.66,5.22,1.65,10.65,2.42,16.12,2.28,.44-.01,.44,.67,0,.68-1.83,.05-3.65-.02-5.46-.17,1.19,4.65,2.69,9.21,4.68,13.58,1.99,4.38,4.41,8.54,6.91,12.65,.23,.38-.36,.72-.59,.34-1.84-3.02-3.63-6.08-5.24-9.23-.15,3.76-.6,15.36-1.11,30.74-.88,26.54-7.62,69.69-9.5,81.33h-.69c1.85-11.45,8.63-54.76,9.51-81.35,.6-18.18,1.12-31.1,1.16-32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.69,354.22c6.06-.33,12.13-.17,18.17,.49,.43,.05,.44,.73,0,.68-6.04-.65-12.11-.82-18.17-.49-.44,.02-.44-.66,0-.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.84,354.28c-.47-8.33-10.85-43.7-10.95-44.05-.05-.18,.05-.37,.23-.42,.18-.05,.37,.05,.42,.23,.43,1.46,10.5,35.8,10.98,44.21,.41,7.23-10.41,74.11-10.87,76.95-.03,.17-.17,.29-.34,.29-.02,0-.04,0-.06,0-.19-.03-.31-.21-.28-.39,.11-.7,11.27-69.64,10.86-76.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.94,306.56c-7.82-2.95-10.34-11.53-12.21-18.86-.11-.43,.55-.61,.66-.18,1.79,7.06,4.17,15.53,11.73,18.38,.41,.15,.23,.81-.18,.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.44,354.87c5.08-.32,10.16-.64,15.24-.96,.44-.03,.44,.66,0,.68-5.08,.32-10.16,.64-15.24,.96-.44,.03-.44-.66,0-.68Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M73.41,184.79c-.86,.07-14.83,4.07-16.2,14.97-1.36,10.9,2.57,70.07,2.61,71.59,.04,1.51-.31,10.9,1,12.72,1.31,1.82,16.45,6.21,35.22,1.67,18.77-4.54,25.02-4.92,25.99-7.76,.96-2.84-4.46-23.28-4.17-26.61s-8.63-58.06-8.63-58.06c0,0-20.38-9.76-35.82-8.5Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3,216.75s.43,42.54,5.79,46.68c5.37,4.15,15.86,.21,15.86,.21l-4.59-29.39-17.07-17.5Z",
    style: {
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.05,184.68s3.06-4.75,3.6-5.28,11.85,1.6,16.65,3.6,5.06,4.66,5.06,4.66v2.82l-25.3-5.8Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.35,190.04s-7.98-3.12-13.98-4.34c-6.01-1.22-11.32-1.02-11.32-1.02l25.3,5.36Z",
    style: {
      opacity: 0.3
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M104.1,245.89s1.71,16.15,10.71,15.19c9-.96,23.31-11.39,23.31-11.39,0,0,6.48,4.27,7.99,2.77s1.37-3.11,1.37-3.11c0,0,1.51-2.09,1.37-3.45-.14-1.37,.96-2.74,.96-4.52s-.55-3.71-1.51-3.77c-.96-.06-6.07,0-6.07,0v-3.34s-5.56,2.46-6.38,4.65c-.82,2.19-1.23,2.74-1.23,2.74l-13.19,1.59-.22-4.64-17.1,7.29Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.29,193.09s-9.8,6.29-9.53,16.27c.27,9.99,4.76,38.75,4.76,38.75,0,0,7.2,.07,13.2-2.75,6.32-2.97,8.67-6.44,8.67-6.44,0,0-3.43-22.44-5.33-30.9s-6.53-15.28-11.78-14.94Z",
    style: {
      fill: "#2F8DE4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.42,243.24l-2.21,3.87s2.15-.58,3.07-3.98l-.86,.1Z",
    style: {
      opacity: 0.3
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTvIllustration);
export default __webpack_public_path__ + "static/media/tv_illustration.c637e4e00ea4dc1d6623b90cb9c6c68a.svg";
export { ForwardRef as ReactComponent };